import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { colors } from "colors";
import { useDispatch, useSelector } from "react-redux";
import ConversationAttachments from "components/chat/ConversationAttachments";
import { snapshotToArray } from "utils/react-lib/generic-ui/firebaseUtils";
import { useCollection } from "react-firebase-hooks/firestore";
import { collection, query, where } from "firebase/firestore";
import { db } from "firebaseApp";
import { COLLECTIONS } from "firebaseCollections";
import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";
import { useTheme } from "@emotion/react";
import { chatActions } from "store/chat";

export default function AttachmentList({
  label = "Files & Attachments",
  targetId,
  ...props
}) {

  const dispatch = useDispatch();

  const theme = useTheme();
  const auth = useAuth();

  const q = targetId
    ? query(
        collection(db, COLLECTIONS.attachments),
        where("uid", "==", auth.currentUser.uid),
        where("targetId", "==", targetId)
      )
    : null;

  const [attachmentsSnap, loading, error] = useCollection(q);

  if (error) {
    console.log(error);
  }

  useEffect(() => {
    dispatch(chatActions.setHasAttachments(attachmentsSnap && attachmentsSnap.docs.length > 0));
  }, [attachmentsSnap]);

  const attachments = snapshotToArray(attachmentsSnap);

  if (attachments.length === 0) return null;

  return (
    <Accordion data-testid="bot-files-accordion" {...props}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: theme.palette.text.main }} />}
      >
        <Typography
          variant="caption"
          fontWeight="bold"
          sx={{
            color: theme.palette.text.main,
          }}
        >
          {label} ({attachments.length})
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ConversationAttachments attachments={attachments} />
      </AccordionDetails>
    </Accordion>
  );
}
